import { FC } from 'react';
import { Icon, Avatar } from 'learning-panel-components';
import { translate } from 'translations';
import styles from './quizBar.module.scss';

interface QuizBarProps {
    currentQuestionIndex: number;
    totalQuestions: number;
    profilePictureUrl: string;
    nickname: string;
    questionStatuses: { key: number; value: string }[];
}

const QuizBar: FC<QuizBarProps> = ({
    totalQuestions,
    currentQuestionIndex,
    nickname,
    profilePictureUrl,
    questionStatuses
}) => {
    const stepWidth = 100 / totalQuestions;
    const progressWidth = stepWidth * currentQuestionIndex;

    const generateStatus = (index: number) => {
        const status = questionStatuses[index]?.value;
        switch (status) {
            case 'correct':
                return <Icon name="checkAdmin" className={styles['icon-success']} key={'checkAdmin'} />;
            case 'incorrect':
                return <Icon name="close" className={styles['icon-failed']} key={'close'} />;
            case 'question':
            default:
                return <Icon name="questionMarkAdmin" className={styles.icon} key={'questionMark'} />;
        }
    };

    return (
        <div className={styles['quiz-bar-wrapper']}>
            <div className={styles['questions-wrapper']}>
                <div>
                    <span className={styles.question}>{translate('Questions')}</span>
                    <span className={styles['red-text']}>{currentQuestionIndex + 1}/</span>
                    <span className={styles['black-text']}>{totalQuestions}</span>
                </div>
            </div>
            <div className={styles['progress-bar']}>
                <div
                    className={styles['progress-overlay']}
                    style={{
                        width: `${progressWidth}%`,
                        background: 'linear-gradient(106deg, #EB53FF 4.51%, #6DEAFF 143.77%)',
                        borderRadius: '6px',
                        boxShadow: '0px 0px 19.8px 0px #3A6471'
                    }}
                ></div>
                {[...Array(totalQuestions)].map((_, index) => (
                    <div key={index} className={`${styles.divider}`} style={{ left: `${index * stepWidth}%` }}>
                        {generateStatus(index)}
                    </div>
                ))}
                <div
                    className={styles['user-avatar']}
                    style={{
                        left: `calc(${currentQuestionIndex * stepWidth}% - 15px)`
                    }}
                >
                    <Avatar name={nickname} avatarSrc={profilePictureUrl} />
                </div>
            </div>
        </div>
    );
};

export default QuizBar;
